import { get } from "lodash";

export const user_metadata = JSON.parse(localStorage.getItem("user") || null);
const snop = JSON.parse(localStorage.getItem("snop") || null);
export const selected_business_unit = JSON.parse(localStorage.getItem("selected_business_unit") || null);

export const buId = selected_business_unit?.business_unit_id || null;
export const tenantId = user_metadata?.tenant_id || null;
export const custom_permissions = user_metadata?.custom_permissions || {};

export const snopId = snop?.snop_id || null;
export const firstName = get(user_metadata, "first_name", "");
export const lastName = get(user_metadata, "last_name", "");
export const businessUnitName = selected_business_unit?.business_unit_name;
export const userRole = get(user_metadata, "roles", []);
export const business_units = get(user_metadata, "business_units") || [];
export const userId = user_metadata?.user_id || null;
